export default __webpack_public_path__ + "static/media/pets.34b9060c.svg";